import { render, staticRenderFns } from "./StartupItemDisplayer.vue?vue&type=template&id=3ba247a6&scoped=true&"
import script from "./StartupItemDisplayer.vue?vue&type=script&lang=js&"
export * from "./StartupItemDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./StartupItemDisplayer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StartupItemDisplayer.vue?vue&type=style&index=1&id=3ba247a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba247a6",
  null
  
)

export default component.exports